var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlourish1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 598.4600219726562 598.4600219726562",
    id: "Layer_2",
    width: 120,
    height: 127,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1, 1)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff0d7;\n        stroke-width: 0px;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M100.67,179.35l-8.98,6.91,11.31-.6c1.37-.07,2.88-.11,4.6-.11,60.69,0,110.07,50.26,110.07,112.03s-49.38,112.01-110.07,112.01c-1.53,0-3.09-.04-4.63-.12l-11.29-.59,8.96,6.9c25.43,19.58,55.79,29.93,87.79,29.93,43.76,0,83.07-19.73,109.8-50.89,26.72,31.16,66.03,50.89,109.79,50.89,32,0,62.36-10.35,87.79-29.93l8.96-6.9-11.29.59c-1.55.08-3.11.12-4.63.12-60.69,0-110.07-50.25-110.07-112.01s49.38-112.03,110.07-112.03c1.73,0,3.23.04,4.6.11l11.31.6-8.98-6.91c-25.43-19.56-55.78-29.9-87.76-29.9-43.76,0-83.07,19.73-109.79,50.89-26.72-31.16-66.04-50.89-109.8-50.89-31.98,0-62.33,10.34-87.76,29.9ZM408.03,156.49c26.8,0,52.4,7.64,74.65,22.18-61.71,3.28-110.94,55.36-110.94,118.91s49.23,115.63,110.95,118.89c-22.25,14.55-47.85,22.19-74.66,22.19-42.07,0-79.82-19.18-105.27-49.39,19.62-25.24,31.34-57.1,31.34-91.69s-11.73-66.45-31.34-91.69c25.44-30.21,63.19-49.39,105.27-49.39ZM298.23,383.6c-18.06-23.83-28.83-53.67-28.83-86.02s10.76-62.2,28.83-86.02c18.06,23.83,28.83,53.67,28.83,86.02s-10.76,62.2-28.83,86.02ZM293.7,205.89c-19.62,25.24-31.34,57.1-31.34,91.69s11.73,66.45,31.34,91.69c-25.44,30.21-63.19,49.39-105.27,49.39-26.81,0-52.41-7.64-74.66-22.19,61.72-3.27,110.95-55.35,110.95-118.89s-49.22-115.63-110.94-118.91c22.25-14.54,47.85-22.18,74.65-22.18,42.07,0,79.82,19.18,105.27,49.39Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21,172.98c5.22-13.83,16.23-24.81,30.08-29.99-13.85-5.2-24.87-16.18-30.08-30.01-5.22,13.83-16.19,24.79-30.05,30.01,13.83,5.18,24.83,16.16,30.05,29.99Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.85,91.41c7.07,2.65,12.7,8.26,15.37,15.34,2.67-7.07,8.3-12.69,15.39-15.34-7.08-2.66-12.72-8.27-15.39-15.35-2.67,7.07-8.28,12.68-15.37,15.35Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.75,68.02V3.52c0-1.95-1.58-3.52-3.52-3.52s-3.52,1.58-3.52,3.52v64.5c0,1.94,1.58,3.52,3.52,3.52s3.52-1.58,3.52-3.52Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.25,423.49c-5.22,13.83-16.23,24.81-30.08,29.99,13.85,5.2,24.87,16.18,30.08,30.01,5.22-13.83,16.19-24.79,30.05-30.01-13.83-5.18-24.83-16.16-30.05-29.99Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.61,505.06c-7.07-2.65-12.7-8.26-15.37-15.34-2.67,7.07-8.3,12.69-15.39,15.34,7.08,2.66,12.72,8.27,15.39,15.35,2.67-7.07,8.28-12.68,15.37-15.35Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.75,528.44c0-1.94-1.58-3.52-3.52-3.52s-3.52,1.58-3.52,3.52v64.5c0,1.94,1.58,3.52,3.52,3.52s3.52-1.58,3.52-3.52v-64.5Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.49,297.56c13.83,5.22,24.81,16.23,29.99,30.08,5.2-13.85,16.18-24.87,30.01-30.08-13.83-5.22-24.79-16.19-30.01-30.05-5.18,13.83-16.16,24.83-29.99,30.05Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.4,297.57c-7.07-2.67-12.68-8.28-15.35-15.37-2.65,7.07-8.26,12.7-15.34,15.37,7.07,2.67,12.69,8.3,15.34,15.39,2.66-7.08,8.27-12.72,15.35-15.39Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.94,294.06h-64.5c-1.94,0-3.52,1.58-3.52,3.52s1.58,3.52,3.52,3.52h64.5c1.94,0,3.52-1.58,3.52-3.52s-1.58-3.52-3.52-3.52Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.98,297.6c-13.83-5.22-24.81-16.23-29.99-30.08-5.2,13.85-16.18,24.87-30.01,30.08,13.83,5.22,24.79,16.19,30.01,30.05,5.18-13.83,16.16-24.83,29.99-30.05Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.06,297.59c7.07,2.67,12.68,8.28,15.35,15.37,2.65-7.07,8.26-12.7,15.34-15.37-7.07-2.67-12.69-8.3-15.34-15.39-2.66,7.08-8.27,12.72-15.35,15.39Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.02,301.1c1.94,0,3.52-1.58,3.52-3.52s-1.58-3.52-3.52-3.52H3.52c-1.94,0-3.52,1.58-3.52,3.52s1.58,3.52,3.52,3.52h64.5Z",
    className: "cls-1",
    vectorEffect: "non-scaling-stroke",
    style: {
      fill: "rgb(131, 69, 79)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlourish1);
export default __webpack_public_path__ + "static/media/flourish1.fe937e08bf4b9699bef28dab638579f8.svg";
export { ForwardRef as ReactComponent };